export default function loadHeroImage(images) {
  if (images.background_image_url_1x) {
    if (window.innerWidth >= "1444px") {
      return images.background_image_url_3x
    } else {
      return images.background_image_url_2x
    }
  } else {
    return null
  }
}
